import axios from 'axios';

const host = process.env.REACT_APP_API_V2;
const headers = {
  'X-Space': 'sure',
};
const axiosOverride = axios.create();
axiosOverride.defaults.headers.common = headers;

function useLoginToken(token) {
  return new Promise((resolve, reject) => {
    axiosOverride
      .post(`${host}/api/v2/clients/token-login/`, {
        token,
      })
      .then(response => {
        return resolve(response);
      })
      .catch(error => reject(error));
  });
}

export default useLoginToken;
